const config = {
  url: {
    server: process.env.VUE_APP_URL_SERVER,
    devServer: process.env.VUE_APP_URL_DEV_SERVER
  },

  appId: '721e687da7278630',

  cid: '88fcc57b9b1c561cdc2e4518b105c369',

  routeNoLoginRequired: [
    'Login',
    'Resources'
    // 'Home',
    // 'Cctv',
    // 'FacialRecognition',
    // 'AnomalyDetection',
    // 'Rollcall',
    // 'Monitor'
  ],

  prizeQuizDefaultCategoryId: 1,
}

export default config
